import { Component, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbValidationModule } from 'mdb-angular-ui-kit/validation';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-read-only-input',
  imports: [
    FormsModule,
    MdbFormsModule,
    MdbValidationModule,
    ReactiveFormsModule,
    TranslateModule

  ],
    templateUrl: './read-only-input.component.html',
    standalone: true,
    styleUrl: './read-only-input.component.scss'
})
export class ReadOnlyInputComponent {
  value = input.required<any>();
  label = input.required<string>();
  disabledStyle = input<boolean>(true)
  white = input<boolean>(false)
  textArea = input<boolean>(false)
}
